/** Fired by the import modal with the run to follow (JBWEB-1266). */
export const INVOICE_IMPORT_STARTED = 'invoice_import_started';
// The detail panel found the invoice already settled: the page's list is stale.
export const INVOICE_LIST_STALE = 'invoice_list_stale';

/** "{done} / {total}" filled in; split and join, so a "$&" in a value stays text. */
export const fillText = (template, values) =>
  Object.entries(values).reduce(
    (text, [key, value]) => text.split(`{${key}}`).join(String(value)),
    template,
  );

/** "juin 2026" for "2026-06". */
export const monthLabel = (period) => {
  const [year, month] = String(period).split('-').map(Number);
  return new Date(year, month - 1, 1).toLocaleDateString('fr-FR', {
    month: 'long',
    year: 'numeric',
  });
};

/**
 * An import or a retry refused while an invoice of the month is being saved
 * (409 INVOICE_INFORMATION_SAVING, JBWEB-1275): there is no run to follow, the
 * lock lasts seconds. Read in the `invoiceImport` space.
 */
export const INFORMATION_SAVING_CODE = 'INVOICE_INFORMATION_SAVING';
export const INFORMATION_SAVING_TEXT = {
  key: 'informationSaving',
  fallback:
    'Une facture de ce mois est en cours d’enregistrement, réessayez dans un instant.',
};

/**
 * "Import de 3 factures" for the import of a list (JBWEB-1274, `scope:
 * "list"`), or null for an import of the month, a retry or a run older than
 * the scope, which keep their own label. `prefix` is where the two keys sit
 * in the caller's space.
 */
export const listImportLabel = (text, run, prefix = '') => {
  if (run?.scope !== 'list' || !Number.isInteger(run.invoiceCount)) return null;
  return run.invoiceCount === 1
    ? text(`${prefix}listImportOne`, 'Import de 1 facture')
    : fillText(text(`${prefix}listImportMany`, 'Import de {count} factures'), {
        count: run.invoiceCount,
      });
};
